import React, { FC } from 'react';
import { ReactComponent as MascotQuestion } from '../../../assets/svg/stickers/Mascot/Mascot_question.svg';
import { IconComp } from '../IconComponent';
import { ButtonSizes, SKButton } from '../Button';
import { useHistory } from 'react-router-dom';
import { Routes } from '../../../constants/routes';
import { ReactComponent as ArrowRight } from '../../../assets/svg/icons/arrow-right.svg';
import { useBreakpoint } from '../../../hooks/useBreakpoint';
import cls from 'classnames';

export interface INoDataContainer {
  message1?: string;
  message2?: string;
  description?: string;
  hasCta: boolean;
  color: string;
}

export const NoDataContainer: FC<INoDataContainer> = ({ message1, message2, description, hasCta, color }) => {
  const history = useHistory();
  const isBiggerThanMobile = useBreakpoint('48em');
  return (
    <div
      className={cls('flex justify-center items-center min-h-screen border-t border-cloud-900', {
        'bg-grape-400': color === 'grape',
        'bg-kiwi-400': color === 'kiwi',
        'bg-onion-50': color === 'onion',
      })}
    >
      <div className="flex flex-col items-center max-w-33.75  px-2 text-center">
        <IconComp icon={MascotQuestion} size={isBiggerThanMobile ? 470 : 300} className="-mb-4" />
        <h4 className="text-display-lg text-cloud-900">{message1}</h4>
        <h4 className="text-display-lg text-cloud-900 mb-2">{message2}</h4>
        <p className="text-lg text-cloud-900 mb-3">{description}</p>
        {hasCta && (
          <SKButton
            className="w-full"
            color="secondary"
            size={ButtonSizes.XL}
            onClick={(): void => history.push(Routes.CREATE_SWAP)}
            iconRight={ArrowRight}
          >
            <p className="text-base text-cloud-900">Create a swap</p>
          </SKButton>
        )}
      </div>
    </div>
  );
};
